<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabBasicMixin],
  data: function () {
    return {
      collectionsContent: null
    };
  },
  mounted() {
    this.loadCollections();
  },
  methods: {
    loadCollections() {
      if (this.content.parent_names && this.content.parent_names.length > 0) {
        Fandom.ajax({
          url: Fandom.applyContextToUrl('/api/v5/get_contents_by_names'),
          method: "POST",
          data: {
            contents_names: this.content.parent_names,
            content_filtering: [this.collectionTag],
            layout_extra_field_name: "$none",
            layout: "tile"
          },
          success: (data) => {
            Fandom.getContentsCallback(data.main_content_name, data);
            Vue.set(this, "collectionsContent", data.name_to_content[data.main_content_name]);
          }
        })
      }
    }
  },
  computed: {
    collectionTag() {
      return get(globalState, ["pageModel", "layout", "content", "collection_tag"], 'tag-collection');
    },
    image() {
      let imageUrl = get(this.content, ['image', 'url'], false);
      if (globalState.viewport.xs || globalState.viewport.sm) {
        imageUrl = get(this.content, ['thumbnail_mobile', 'url'], imageUrl);
      }
      return `url(${imageUrl})`;
    }
  }
};
</script>

<template>
  <div
    v-if="isContentVisibleToUser()"
    v-easyadmin="easyadminId"
    :class="contentType"
    page-collection-component
    class="position-relative"
  >
    <breadcrumb></breadcrumb>
    <div class="bg-cover-center d-flex align-items-md-center page-header" :style="{'background-image': image}">
      <div class="container-md container px-md-4 pt-md-5">
        <div class="row px-4 px-md-0">
          <div class="col-12" v-if="category">
            <div
              v-if="category"
              class="category small my-4 d-inline-block px-3 py-1"
              :class="this.content.theme == 'dark' ? 'white' : 'primary'"
            >{{category}}</div>
          </div>
          <div class="col-12 col-md-8 col-lg-6" :class="this.content.theme == 'dark' ? 'text-white' : 'text-black'">
            <h1 class="display-1 mb-1" v-if="content.title">{{content.title}}</h1>
            <p class="mb-4 mb-md-5" v-if="content.description" v-html="content.description"></p>
            <div class="small mb-4 mb-md-5" v-if="content.children_count">{{content.children_count}} {{ft('globals.contents')}}</div>
            <a :href="content.button.url" :target="getTarget(content.button)" class="btn mb-4 mb-md-5" :class="content.button_class || 'btn-primary'" v-if="content.button">{{content.button.title}}</a>
          </div>
        </div>
      </div>
    </div>
    <grid-isotope tile-size="ultrawidecontent" :content="content" :opt-container-content="containerContent" inherit-theme-type="light"></grid-isotope>
    <!-- <component
      :key="stripe.$id"
      :content="stripe"
      :is="stripe.layout"
      :opt-container-content="containerContent"
      v-for="(stripe) in content.stripes"
    ></component> -->
  </div>
</template>

<style lang="scss">
[page-collection-component] {

  .page-header {
    min-height: 70vh;

    @include media-breakpoint-up(md) {
      min-height: 60vh;
    }
  }
}
</style>
